import ReportNoveltyTree from './ReportNoveltyTree';
export default ReportNoveltyTree;
